/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Force_Render_AudioInputs */



/**
* | output |
* | --- |
* | "Force Render Audio..." |
*
* @param {Force_Render_AudioInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const force_render_audio = /** @type {((inputs?: Force_Render_AudioInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Force_Render_AudioInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Forcer le rendu audio...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audio erzwingen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Forza rendering audio...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Принудительное воспроизведение звука...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Forzar renderizado de audio...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("强制渲染音频...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーディオの強制レンダリング...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो को जबरदस्ती रेंडर करें...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Forçar renderização de áudio...")
	return /** @type {LocalizedString} */ ("Force Render Audio...")
});